'use client';

import { c as _c } from "react/compiler-runtime";
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react';
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid';
import Image from 'next/image';
import { getBuilderPreviewMode } from '@src/utils/builder.util';
import { cn } from '@src/utils/tailwind';
import type { SKUSelectorDropdownOption } from './SKUSelectorDropdownProps';
type DropdownProps = {
  dropdownOptions?: SKUSelectorDropdownOption[];
  activeOption?: SKUSelectorDropdownOption;
  selectedSku: string;
  isLoading: boolean;
  onChange: (sku: string) => void;
  previewAllItems?: boolean;
};
export function Dropdown(t0) {
  const $ = _c(26);
  const {
    dropdownOptions,
    activeOption,
    selectedSku,
    isLoading,
    onChange,
    previewAllItems: t1
  } = t0;
  const previewAllItems = t1 === undefined ? false : t1;
  const isPreview = previewAllItems && getBuilderPreviewMode().edit;
  const renderOption = _temp;
  if (isPreview) {
    let t2;
    if ($[0] !== dropdownOptions) {
      t2 = dropdownOptions?.map(option_0 => <div className="flex flex-col gap-0 rounded-lg border-2 border-dashed border-bodi-blue-info p-4" key={option_0.sku}>{option_0.contentTop}<div className="my-4 h-px border border-dashed border-bodi-blue-info" />{renderOption(option_0)}</div>);
      $[0] = dropdownOptions;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== t2) {
      t3 = <div className="flex flex-col gap-4 px-4 pb-4">{t2}</div>;
      $[2] = t2;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  const t2 = activeOption?.contentTop;
  let t3;
  if ($[4] !== activeOption) {
    t3 = activeOption ?? {};
    $[4] = activeOption;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = renderOption(t3);
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ChevronUpDownIcon className="size-4" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4) {
    t6 = <ListboxButton className="flex w-full items-center justify-between rounded-lg p-4 text-left outline outline-1 outline-bodi-gray-butters">{t4}{t5}</ListboxButton>;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = cn("mt-2 w-(--button-width) origin-top rounded-lg bg-bodi-white py-2 outline outline-1 outline-bodi-gray-butters drop-shadow-md", "transition duration-200 ease-out data-closed:scale-95 data-closed:opacity-0");
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== dropdownOptions || $[13] !== selectedSku) {
    t8 = dropdownOptions?.map(option_1 => <ListboxOption key={option_1.sku} value={option_1.sku} className="flex items-center gap-2 p-3 text-left hover:bg-bodi-accent-bright-300"><CheckIcon className={cn("size-5 text-transparent", option_1.sku === selectedSku && "text-bodi-accent-deep-500")} />{renderOption(option_1)}</ListboxOption>);
    $[12] = dropdownOptions;
    $[13] = selectedSku;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t8) {
    t9 = <ListboxOptions anchor="bottom" transition={true} className={t7}>{t8}</ListboxOptions>;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== isLoading || $[18] !== onChange || $[19] !== selectedSku || $[20] !== t6 || $[21] !== t9) {
    t10 = <Listbox value={selectedSku} onChange={onChange} disabled={isLoading}>{t6}{t9}</Listbox>;
    $[17] = isLoading;
    $[18] = onChange;
    $[19] = selectedSku;
    $[20] = t6;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t2) {
    t11 = <div className="flex w-full flex-col">{t2}{t10}</div>;
    $[23] = t10;
    $[24] = t2;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
}
function _temp(option) {
  return <div className="flex items-center">{option.hasImage && <Image src={option.image?.src ?? ""} alt={option.image?.altText ?? ""} width={option.image?.width ?? 0} height={option.image?.height ?? 0} style={{
      marginRight: `${option.image?.rightSpacing ?? 0}px`
    }} />}{option.label}{option?.descriptor && <><span className="mx-2">—</span><span className="text-bodi-accent-deep-500">{option.descriptor}</span></>}</div>;
}